var render = function render(){var _vm=this,_c=_vm._self._c;return _c('trax-ui-card',{attrs:{"align":"center","background-color":"primary"}},[_c('h2',[_vm._v(_vm._s(_vm.lang.polaris.form.save_all))]),_vm._v(" "),_c('button',{staticClass:"btn btn-round btn-lg btn-white text-primary mb-3",attrs:{"type":"button"},on:{"click":_vm.saveAll}},[_vm._v("\n        "+_vm._s(_vm.lang.polaris.form.save)+"\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }